import './bio.css';

const BioComponent = () => {
  return (
    <div>
      <div className="header">Biography</div>

      <div className="bioCard">

        <div className="bioImageContainer">
          <img
            alt="Mark S. Roberts"
            className="bioImage"
            src="images/MARK_S_ROBERTS.jpg"
          />
        </div>

        <div className="bioContent">
          <p className="bioDetail">
            Mark S. Roberts was born into a military family and followed in his father's footsteps. He served in the United States Air Force as a security policeman for 20 years and is a Desert Storm veteran. Mark holds a bachelor's degree in administration in criminal justice. He and his wife, Lori (also a USAF veteran) lived in Charlotte, North Carolina, after his retirement for many years before moving to a small town just outside Green Bay, Wisconsin, where they currently reside.
          </p>
          <p className='bioDetail'>
            Mark was raised in Jacksonville, Florida, and has lived and served in locations around the world. He and Lori travel whenever possible and have visited all fifty states. They enjoy the national parks and many historical places throughout the lands, including many civil war sites. In addition to travelling, he likes to golf, woodwork, hike, and attend the occasional Jacksonville Jaguars game.  
          </p>
        </div>
      </div>

    </div>
  );
};

export default BioComponent;
